import { useEffect } from 'react';

import { setupDecagon } from '../common/support';

export default function SupportSetup() {
  useEffect(() => {
    setupDecagon();
  }, []);

  return null;
}
